import { render, staticRenderFns } from "./BrandPublicationStatus.vue?vue&type=template&id=5f159cda"
import script from "./BrandPublicationStatus.vue?vue&type=script&lang=js"
export * from "./BrandPublicationStatus.vue?vue&type=script&lang=js"
import style0 from "./BrandPublicationStatus.vue?vue&type=style&index=0&id=5f159cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports